export enum EnumActionMedia {
    Email = 'email',
    Social = 'social',
    Link = 'link',
    Location = 'location',
    Call = 'call'
}

export enum EnumMediaCircle {
    Facebook = 'facebook',
    Instagram = 'instagram',
    Youtube = 'youtube',
    GoogleMap = 'googlemap',
    Whatsapp = 'whatsapp',
    Call = 'call'
}

export enum EnumIcons {
    Text = 'text',
    Call = 'call',
    Email = 'email',
    Location = 'location',
    Postcard = 'postcard',
    Profile = 'profile',
    Website = 'website',
    Featured_Content = 'featured_content',
    Social_Link = 'social_link',
    Share = 'share',
    Connect = 'connect'
}